import { DynamicInput, PageFilterModule as PageFilterModuleBase } from '@domain-group/suit-theme'
import type { PageFilterModuleProps as PageFilterModuleBaseProps } from '@domain-group/suit-theme'

import searchEndpoint from '@functions/search'

import useSelector from '@hooks/useSelector'

import EntitySelector from '@components/EntitySelector'

const supportedComponents = {
  DynamicInput,
  EntitySelector,
}

type PageFilterModuleProps = Omit<PageFilterModuleBaseProps, 'entities' | 'supportedComponents'>

const PageFilterModule = (props: PageFilterModuleProps) => {
  const { callbacks, ...restProps } = props

  const entities = useSelector(reduxState => reduxState.entities)

  return (
    <PageFilterModuleBase
      // @ts-expect-error TS2353
      callbacks={{ ...callbacks, searchEndpoint }}
      // @ts-expect-error TS2322
      entities={entities}
      supportedComponents={supportedComponents}
      {...restProps}
    />
  )
}

export default PageFilterModule
